import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { GetProvidersUseCase } from './GetProvidersUseCase';
import { GetFooterMenuContentUseCase } from './GetFooterMenuContent';
import { GetHeaderMenuContentUseCase } from './GetHeaderMenuContent';
import { GetMoodsUseCase } from './GetMoodsUseCase';
import { GetGamesUseCase } from './GetGamesUseCase';
import { GetProfileAvatarUseCase } from './GetProfileAvatarUseCase';

export const initializeCustomConfigurationUseCases = (container: Container) => {
    container.register(DI.USECASES.IGetProvidersUseCase, {
        useClass: GetProvidersUseCase,
    });
    container.register(DI.USECASES.IGetFooterMenuContentUseCase, {
        useClass: GetFooterMenuContentUseCase,
    });
    container.register(DI.USECASES.IGetHeaderMenuContentUseCase, {
        useClass: GetHeaderMenuContentUseCase,
    });
    container.register(DI.USECASES.IGetMoodsUseCase, {
        useClass: GetMoodsUseCase,
    });
    container.register(DI.USECASES.IGetGamesUseCase, {
        useClass: GetGamesUseCase,
    });
    container.register(DI.USECASES.IGetProfileAvatarsUseCase, {
        useClass: GetProfileAvatarUseCase,
    });
};
